import React,{useEffect} from "react";

import {
  FaFacebook,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";
import OpacityLoading from "../Loading/OpacityLoading";
import "./Contact.css";
import AOS from "aos";


function Contact() {

  
  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <>
      <OpacityLoading>
        <div className="contact-hero">
          <h1 data-aos="fade-right">Contact Me</h1>
        </div>
        <section>
          <div className="container contact">
            <div className="contact-info  " data-aos="fade-right">
              <div>
                <h2>Contact Info</h2>
                <ul className="info">
                  <li>
                    <span></span>
                    <span>
                      124 madrasha road ,<br />20/4 house <br />
                      savar, dhaka
                    </span>
                  </li>
                  <li>
                    <span></span>
                    <span>hhshiblu5555@gmail.com</span>
                  </li>
                  <li>
                    <span></span>
                    <span>(+880)1782572426</span>
                  </li>
                </ul>
                <ul className="sci">
                  <li>
                  <a href="https://www.facebook.com/profile.php?id=100085191756581">
                  <FaFacebook />
                </a>
                  </li>
                  <li>
                  <a href="https://www.linkedin.com/in/hasanul-haque-shiblu-323737263/">
                  <FaLinkedinIn />
                </a>
                  </li>
                
                  <li>
                  <a href="https://github.com/hhshiblu">
                  <FaGithub />
                </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="contact-form" data-aos="fade-right">
              <h2>sand a massage</h2>

              <div className="form-box">
                <div className="inputBox w50">
                  <input type="text" name="firstNamet" required />
                  <span>First name</span>
                </div>
                <div className="inputBox w50">
                  <input type="text" name="lastName" required />
                  <span>last name</span>
                </div>
                <div className="inputBox w50">
                  <input type="email" name="email" required />
                  <span>Email Adress</span>
                </div>
                <div className="inputBox w50">
                  <input type="number" name="number" required />
                  <span>Phone Number</span>
                </div>
                <div className="inputBox w100">
                  <textarea type="text-area" name="text" required />
                  <span> Write your massage here</span>
                </div>
                <div className="inputBox w50">
                  <input type="submit" value="sand" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </OpacityLoading>
    </>
  );
}

export default Contact;
